import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

const DateRange = (props) => {
    return (
        <div className="flex items-center relative h-full">
            <DatePicker
                id="dprdate"
                autoComplete="off"
                selectsRange
                isClearable
                startDate={props.startDate}
                endDate={props.endDate}
                onChange={props.handleDateRange}
                dateFormat="dd/MM/yyyy"
                className="custom-form-control w-full h-full pl-3 pr-8"
                placeholderText="Pilih Tanggal"
            />
            <FontAwesomeIcon icon={faCalendar} className="absolute right-3 text-gray-500" />
        </div>
    );
};

export default DateRange;